import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { cardCls } from "./ui";

const Stat = ({ label, value }) => (
  <div className={`${cardCls} p-6`}>
    <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-midnight/40">{label}</p>
    <p className="font-heading text-3xl font-light text-midnight mt-2">{value}</p>
  </div>
);

export const SeoSection = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/seo/overview", { params: { range: "month" } }).then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <p className="text-sm text-midnight/40 animate-pulse">Loading SEO data…</p>;

  return (
    <div data-testid="admin-seo-section">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat label="Organic Sessions (30d)" value={data.organic_sessions} />
        <Stat label="Organic RFQs" value={data.organic_rfqs} />
        <Stat label="Organic Registrations" value={data.organic_registrations} />
      </div>

      <div className="grid lg:grid-cols-2 gap-4 mt-4">
        <div className={`${cardCls} p-6`}>
          <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-gold mb-5">Organic Landing Pages</p>
          {data.landing_pages.length === 0 && <p className="text-sm text-midnight/40">No organic sessions recorded yet.</p>}
          {data.landing_pages.map((p) => (
            <div key={p.label} className="flex justify-between text-sm py-2 border-b border-midnight/[0.06]">
              <span className="text-midnight/70">{p.label}</span>
              <span className="font-medium text-midnight">{p.count}</span>
            </div>
          ))}
        </div>
        <div className={`${cardCls} p-6`}>
          <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-gold mb-5">Top Organic Countries</p>
          {data.organic_countries.length === 0 && <p className="text-sm text-midnight/40">No organic sessions recorded yet.</p>}
          {data.organic_countries.map((c) => (
            <div key={c.label} className="flex justify-between text-sm py-2 border-b border-midnight/[0.06]">
              <span className="text-midnight/70">{c.label}</span>
              <span className="font-medium text-midnight">{c.count}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={`${cardCls} p-6 mt-4`}>
        <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-gold mb-3">Search Console</p>
        <p className="text-sm text-midnight/60 leading-relaxed">{data.note} Sitemap: <span className="font-mono text-xs text-midnight">https://royaldealsfzllc.com/sitemap.xml</span></p>
      </div>
    </div>
  );
};
